import { render, staticRenderFns } from "./SplitOrderSidebar.vue?vue&type=template&id=7924c443"
import script from "./SplitOrderSidebar.vue?vue&type=script&lang=js"
export * from "./SplitOrderSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports